export default __webpack_public_path__ + "images/STEP-stmslogo-fbd52f28.png";